module.exports = __webpack_public_path__ + "img/7.a5414155.png";